import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';
import {
  API_ENDPOINT,
  useClientApiV1BlogsUserUserIdCategoryQuery,
} from '../../../resources/@types/uccSchema';

interface UseClientV1BlogsUserUserIdCategoryQuery {
  userId: number;
  options?: Parameters<typeof useClientApiV1BlogsUserUserIdCategoryQuery>[0]['options'];
}

export const blogsUserUserIdCategoryOptions = (userId: number) => {
  const url = API_ENDPOINT.CLIENT_V1_BLOGS_USER_USERID_CATEGORY(String(userId));
  const queryKey = [url] as QueryKeyReturnType;

  return {
    queryKey,
    url,
  };
};

export function useBlogsUserUserIdCategoryQuery({
  userId,
  options,
}: UseClientV1BlogsUserUserIdCategoryQuery) {
  const { queryKey, url } = blogsUserUserIdCategoryOptions(userId);

  return useClientApiV1BlogsUserUserIdCategoryQuery({
    queryKey,
    url,
    options,
  });
}
